export default "__VITE_ASSET__64b4370d__"